import { Component, OnInit } from '@angular/core';
import { UserManager } from 'oidc-client';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    // do something
  }

  login() {
    // 跳转到IDM登录页面
    const manager: UserManager = new UserManager(environment.authConfig);
    manager.signinRedirect();
  }
}

